import(/* webpackMode: "eager" */ "/home/ubuntu/download/69c4a69e7d947e0014202a7a/detailreveal_1774495390430/src/app/page.tsx");
